import { Category } from '@/types/category';
import { Product } from '@/types/product';

export const productToSlug: Record<Product, string> = {
  [Product.MESSAGE]: 'glip',
  [Product.VIDEO]: 'video',
  [Product.WEBINAR]: 'webinar',
  [Product.EVENTS]: 'events',
  [Product.PHONE]: 'office',
  [Product.AIR]: 'air',
  [Product.ACE]: 'ace',
  [Product.CONTACT_CENTER]: 'contact-center',
  [Product.ENGAGE_DIGITAL]: 'engage-digital',
  [Product.ENGAGE_VOICE]: 'engage-voice',
  [Product.MEETINGS]: 'meetings',
  [Product.SERVICE_WEB]: 'service-web',
};

export const categoryToSlug: Record<Category, string> = {
  [Category.AI]: 'ai',
  [Category.ANALYTICS]: 'analytics',
  [Category.AUDIENCE_ENGAGEMENT]: 'audience-engagement',
  [Category.AUTOMATION]: 'automation',
  [Category.BOTS_NOTIFICATIONS]: 'bots-notifications',
  [Category.CALENDARING]: 'calendaring',
  [Category.CERTIFICATION]: 'certification',
  [Category.COLLABORATION]: 'collaboration',
  [Category.CRM]: 'crm',
  [Category.CUSTOMER_SUPPORT]: 'customer-support',
  [Category.DEVELOPER_TOOLS]: 'developer-tools',
  [Category.EDUCATION]: 'education',
  [Category.ERP]: 'erp',
  [Category.FAX]: 'fax',
  [Category.FINANCIAL_SERVICES]: 'financial-services',
  [Category.HEALTHCARE]: 'healthcare',
  [Category.LABS]: 'labs',
  [Category.LEGAL]: 'legal',
  [Category.MARKETING_AUTOMATION]: 'marketing-automation',
  [Category.PRODUCTIVITY]: 'productivity',
  [Category.RETAIL]: 'retail',
  [Category.SMS]: 'sms',
  [Category.SPEECH]: 'speech',
  [Category.STORAGE]: 'storage',
  [Category.TRANSLATION]: 'translation',
};

export const toProductSlug = (value?: string): string | undefined => {
  if (!value) {
    return undefined;
  }
  return productToSlug[value as Product];
};

export const toCategorySlug = (value?: string): string | undefined => {
  if (!value) {
    return undefined;
  }
  return categoryToSlug[value as Category];
};
